import { render } from "./numberKeyBoard.vue?vue&type=template&id=0d0b48e9"
import script from "./numberKeyBoard.vue?vue&type=script&lang=js"
export * from "./numberKeyBoard.vue?vue&type=script&lang=js"

import "./numberKeyBoard.vue?vue&type=style&index=0&id=0d0b48e9&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__